import isString from 'lodash/isString'
import isObject from 'lodash/isObject'

export const transform2px = (value, relativeValue = 0, rootFontSize = 0) => {
  if (isString(value)) {
    if (/^(\d*.?\d*)%$/.test(value)) {
      return Math.floor(Number(value.match(/^(\d*.?\d*)%$/)[1]) / 100 * relativeValue) || 0
    }
    if (/^(\d*.?\d*)rem$/.test(value)) {
      return rootFontSize * Number(value.match(/^(\d*.?\d*)rem$/)[1])
    }
    if (/^(\d*.?\d*)px$/.test(value)) {
      return Number(value.match(/^(\d*.?\d*)px$/)[1])
    }
  }
  if (Array.isArray(value)) {
    return value.map((v) => {
      if (v === 'auto') {
        return v
      } else {
        return transform2px(v, relativeValue, rootFontSize)
      }
    })
  }
  return Number(value)
}

const handleNotPx = (config, relativeValue, rootFontSize) => {
  Object.entries(([key, value]) => {
    if (key !== 'el') {
      if (isObject(value)) {
        if ((key === 'padding' || key === 'appendPadding') && Array.isArray(value) && value.length > 0 && isString(value[0])) {
          config[key] = value.map(d => transform2px(d, relativeValue, rootFontSize))
        } else {
          handleNotPx(value, relativeValue, rootFontSize)
        }
      } else if (['fontSize', 'radius', 'padding', 'appendPadding'].includes(key)) {
        config[key] = transform2px(value, relativeValue, rootFontSize)
      }
    }
  })
}

export const checkChartConfig = (config) => {
  const { chart } = config
  let chartEl

  if (chart.id) {
    chartEl = document.getElementById(chart.id)
  } else if (chart.el) {
    chartEl = chart.el
  } else {
    throw new Error('请设置正确的 canvas id 或 dom')
  }

  const relativeWidth = chartEl.parentElement.clientWidth
  const relativeHeight = chartEl.parentElement.clientHeight
  const rootFontSize = Number((window.document.documentElement.style.fontSize || '').split('px')[0])

  let { width, height, padding, appendPadding } = chart
  if (!width) {
    width = relativeWidth || 0
  } else {
    width = transform2px(width, relativeWidth, rootFontSize)
  }
  if (!height) {
    height = Math.floor(3 / 4 * width)
  } else {
    height = transform2px(height, relativeHeight, rootFontSize)
  }
  if (padding) {
    padding = transform2px(padding, relativeWidth, rootFontSize)
    chart.padding = Array.isArray(padding) ? (padding.length > 0 ? padding : 'auto') : padding
  }
  if (appendPadding) {
    appendPadding = transform2px(appendPadding, relativeWidth, rootFontSize)
    chart.appendPadding = Array.isArray(appendPadding) ? (appendPadding.length > 0 ? appendPadding : 'auto') : appendPadding
  }

  chart.width = width || 1 // 设置为 0 时有些 f2 依赖宽高的计算会导致 NaN 错误
  chart.height = height || 1
  handleNotPx(config, relativeWidth, rootFontSize)
}
